/* eslint-disable */
import axios from 'axios';
import dotenv from 'dotenv';
import jwt from 'jsonwebtoken';
import router from './../router';

dotenv.config();
var apiIP = '';
if (process.env.VUE_APP_IP_API) {
  apiIP = `${process.env.VUE_APP_IP_API}`;
  if (process.env.VUE_APP_PORT_REST)
    apiIP = apiIP + `:${process.env.VUE_APP_PORT_REST}`;
} else {
  apiIP = 'https://api2.bbonebrasil.com.br';
}

const dominio = window.location.href.toString();
if (dominio.indexOf('qa.') >= 0) {
  apiIP = 'https://qa.bbonebrasil.com.br';
}

const getIdEmpresa = () => {
  const decoded = jwt.decode(localStorage.getItem('user-token'));
  if (decoded) {
    return decoded.id_empresa;
  }
  return null;
};

const getIdUser = () => {
  const decoded = jwt.decode(localStorage.getItem('user-token'));
  if (decoded) {
    return decoded.id_usuario;
  }
  return null;
};
const extractCompanyId = (filter) => {
  const match = /(\d+)\s*$/.exec(filter || '');
  return match ? match[1] : '';
};

const MIGRATED_BPVIDA_MODELS = {
  domUf: () => `${process.env.VUE_APP_API_VIDA_URL}/domains/states`,
  domMunicipio: (filter) => {
    const codUf = (filter || '').replace('codUf/', '');
    return `${process.env.VUE_APP_API_VIDA_URL}/domains/states/${codUf}/cities`;
  },
  domBancos: () => `${process.env.VUE_APP_API_VIDA_URL}/domains/banks`,
  setor: (filter) =>
    `${process.env.VUE_APP_API_VIDA_URL}/sectors?idEmpresa=${extractCompanyId(filter)}`,
  regionais: (filter) => {
    const idEmpresa = extractCompanyId(filter);
    const query = idEmpresa ? `?idEmpresa=${idEmpresa}` : '';
    return `${process.env.VUE_APP_API_VIDA_URL}/auto/regionals${query}`;
  },
  divisoes: () => `${process.env.VUE_APP_API_VIDA_URL}/auto/divisions`,
  domTipoFipe: () => `${process.env.VUE_APP_API_VIDA_URL}/domains/fipe-types`,
  domTipoProdutos: () =>
    `${process.env.VUE_APP_API_VIDA_URL}/domains/product-types`,
  TiposDescontos: () =>
    `${process.env.VUE_APP_API_VIDA_URL}/domains/discount-types`,
  fornecedores: () => `${process.env.VUE_APP_API_VIDA_URL}/suppliers/catalog`,
  produtos: (filter) =>
    `${process.env.VUE_APP_API_VIDA_URL}/auto/products?idEmpresa=${extractCompanyId(filter)}`,
  empresasContasBancarias: (filter) =>
    `${process.env.VUE_APP_API_VIDA_URL}/bank-accounts?idEmpresa=${extractCompanyId(filter)}`,
  domPermissoes: () =>
    `${process.env.VUE_APP_API_VIDA_URL}/permissions-catalog`,
  perfis: () => `${process.env.VUE_APP_API_VIDA_URL}/profiles/catalog`,
  empresas: (filter) =>
    `${process.env.VUE_APP_API_VIDA_URL}/companies?idEmpresa=${extractCompanyId(filter)}`,
  gruposVeiculos: (filter) =>
    `${process.env.VUE_APP_API_VIDA_URL}/auto/vehicle-groups?idEmpresa=${extractCompanyId(filter)}`,
  domTipoPagamento: () =>
    `${process.env.VUE_APP_API_VIDA_URL}/domains/payment-types`,
  domSetor: (filter) =>
    `${process.env.VUE_APP_API_VIDA_URL}/domains/area-sectors?idArea=${extractCompanyId(filter)}`,
  empresasCarteiraCobranca: (filter) =>
    `${process.env.VUE_APP_API_VIDA_URL}/wallet/catalog?idEmpresa=${extractCompanyId(filter)}`,
  convenio: (filter) =>
    `${process.env.VUE_APP_API_VIDA_URL}/admin/reports/covenants/all/${extractCompanyId(filter)}`,
};

export default {
  getJson(jsonName) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint =
          apiIP + '/g/buscaJson/' + process.env.VUE_APP_SITE + '/' + jsonName;

        axios
          .get(endpoint)
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });
      } catch (e) {
        reject(e);
      }
    });
  },
  getAll(controllerName, extraParams, action = 'list') {
    return new Promise((resolve, reject) => {
      try {
        if (controllerName === 'g') {
          const parts = action.split('/').filter(Boolean);
          const model = parts[0];
          if (MIGRATED_BPVIDA_MODELS[model]) {
            const filter = parts.slice(2).join('/');
            const migratedEndpoint = MIGRATED_BPVIDA_MODELS[model](filter);
            const migratedToken = localStorage.getItem('user-token');
            axios
              .get(migratedEndpoint, {
                timeout: 100000,
                headers: { Authorization: migratedToken },
              })
              .then(function (response) {
                resolve(response);
              })
              .catch(function (error) {
                reject(error);
              });
            return;
          }
        }
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        if (extraParams)
          if (extraParams.PageNumber != undefined) {
            if (action == '') {
              endpoint = endpoint + 'Page/' + extraParams.PageNumber;
            } else {
              endpoint = endpoint + '/' + extraParams.PageNumber;
            }
          }
        endpoint = endpoint
          .replace('idEmpresa=null', getIdEmpresa())
          .replace('idEmpresa=undefined', getIdEmpresa())
          .replace('idUsuario=null', getIdUser());

        var token = localStorage.getItem('user-token');

        axios
          .get(endpoint, {
            timeout: 100000,
            headers: {
              Authorization: token,
              'Access-Control-Allow-Origin': '*',
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.status == 401) {
                router.push('/Login');
                reject('Sessão Expirada, efetue novo login');
              }
              if (error.response.data.error) {
                reject(error.response.data.error.errorMessage);
              } else {
                reject('Ação não Encontrada');
              }
            } else {
              // antigo Erro Sistemico
              reject('Falha na conexão com internet, tente novamente');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  getCompanyLogo(idEmpresa) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.VUE_APP_API_VIDA_URL}/public/companies/${idEmpresa}/logo`,
          { timeout: 100000 },
        )
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  getOne(controllerName, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        const endpoint = `${apiIP}/${controllerName}/${extraParams.PrimaryKey}/${extraParams.PageNumber}`;
        axios
          .get(endpoint, {
            extraParams,
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            reject(error);
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  getFilter(controllerName, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        const endpoint = `${apiIP}/${controllerName}/filter/${extraParams.SearchText}?page=${extraParams.PageNumber}`;

        axios
          .get(endpoint, {
            extraParams,
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  post(controllerName, action = 'create', data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;

        if (extraParams)
          if (extraParams.PageNumber != undefined) {
            if (action == '') {
              endpoint = endpoint + 'Page/' + extraParams.PageNumber;
            } else {
              endpoint = endpoint + '/' + extraParams.PageNumber;
            }
          }

        if (!data.idEmpresa && data.idEmpresa != 0)
          data.idEmpresa = getIdEmpresa();

        var token = localStorage.getItem('user-token');
        axios
          .post(endpoint, data, {
            timeout: 100000,
            headers: {
              Authorization: token,
              'Access-Control-Allow-Origin': '*',
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.status == 401) {
                router.push('/Login');
                reject('Sessão Expirada, efetue novo login');
              }
              if (error.response.data.error) {
                reject(error.response.data.error.errorMessage);
              } else {
                reject('Ação não Encontrada');
              }
            } else {
              // antigo Erro Sistemico
              reject('Falha na conexão com internet, tente novamente');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  login(controllerName, action = 'login', data) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        var basicAuth = 'Basic ' + btoa(JSON.stringify(data));
        axios
          .post(
            endpoint,
            {},
            {
              timeout: 100000,
              headers: {
                Authorization: basicAuth,
                'Access-Control-Allow-Origin': '*',
              },
            },
          )
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error && error.response)
              if (error.response.data) {
                if (error.response.data.error) {
                  if (error.response.data.error.errorMessage)
                    reject(error.response.data.error.errorMessage);
                  else reject();
                } else {
                  reject(error);
                }
              }
            if (error) {
              reject();
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  upload(controllerName, action, data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        action = action
          .replace('idEmpresa=null', getIdEmpresa())
          .replace('idUsuario=null', getIdUser());

        var endpoint = `${apiIP}/${controllerName}/${action}`;

        axios
          .post(endpoint, data, {
            timeout: 100000,
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
            },
          })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  uploadAll(controllerName, action, files) {
    return new Promise((resolve, reject) => {
      try {
        action = action.replace('idEmpresa=null', getIdEmpresa());
        const endpoint = `${apiIP}/${controllerName}/${action}`;

        axios
          .post(endpoint, files, {
            timeout: 100000,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  put(controllerName, action = 'update', data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        data.idEmpresa = getIdEmpresa();
        var token = localStorage.getItem('user-token');

        axios
          .put(endpoint, data, {
            timeout: 100000,
            headers: {
              Authorization: token,
              'Access-Control-Allow-Origin': '*',
            },
          })
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.status == 401) {
                router.push('/Login');
                reject('Sessão Expirada, efetue novo login');
              }
              if (error.response.data.error) {
                reject(error.response.data.error.errorMessage);
              } else {
                reject('Ação não Encontrada');
              }
            } else {
              // antigo Erro Sistemico
              reject('Falha na conexão com internet, tente novamente');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  delete(controllerName, action = 'update', data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        var token = localStorage.getItem('user-token');

        data = {
          headers: {
            timeout: 100000,
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
          },
        };
        axios
          .delete(endpoint, data)
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            if (error.response.data.error) {
              reject(error.response.data.error.errorMessage);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  validaToken(token, controllerName, action) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        axios
          .post(
            endpoint,
            {
              front: true,
            },
            {
              headers: {
                timeout: 100000,
                Authorization: token,
                'Access-Control-Allow-Origin': '*',
              },
            },
          )
          .then(function (response) {
            resolve(response);
          })
          .catch(function (error) {
            resolve({
              data: {
                result: false,
              },
            });
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  getLoggedUser() {
    return jwt.decode(localStorage.getItem('user-token'));
  },

  /**
   * Verifica o valor da variável de ambiente VUE_APP_MAINTENANCE, caso possua
   * redireciona para a tela de Manutenção, caso contrario para a tela de Login
   * @param {Object} object this.$router
   */

  maintenance(next) {
    const maintenance = process.env.VUE_APP_MAINTENANCE;
    if (maintenance) {
      return next.push('/maintenance');
    }
  },
};
